import { getToken } from "@/lib/store";

const listeners = new Set();
let ws = null, timer = null, delay = 1000, connected = false;

const url = () => `${process.env.REACT_APP_BACKEND_URL.replace(/^http/, "ws")}/api/ws?token=${getToken()}`;

function connect() {
  if (ws || !getToken()) return;
  try { ws = new WebSocket(url()); } catch (e) { return schedule(); }
  ws.onopen = () => { connected = true; delay = 1000; emit({ type: "open" }); };
  ws.onmessage = (ev) => { try { const d = JSON.parse(ev.data); if (d.type === "ping") ws?.send("ping"); else emit(d); } catch (e) { /* ignore */ } };
  ws.onclose = () => { ws = null; if (connected) { connected = false; emit({ type: "close" }); } schedule(); };
  ws.onerror = () => { try { ws?.close(); } catch (e) { /* noop */ } };
}
function schedule() { if (!listeners.size || timer) return; timer = setTimeout(() => { timer = null; connect(); }, delay); delay = Math.min(delay * 2, 15000); }
function emit(d) { listeners.forEach((fn) => { try { fn(d); } catch (e) { /* listener error */ } }); }

export const realtime = {
  subscribe(fn) { listeners.add(fn); connect(); if (connected) fn({ type: "open" }); return () => { listeners.delete(fn); if (!listeners.size && ws) { ws.close(); ws = null; } }; },
  get connected() { return connected; },
  disconnect() { ws?.close(); ws = null; clearTimeout(timer); timer = null; },
};
